<p-card [header]="(user.id ? 'USERS.EDIT_USER' : 'USERS.CREATE_USER') | translate">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12" novalidate>
    @if (anwenderbetriebOptions.length > 1) {
      <app-form-dropdown
        [filter]="true"
        [form]="form"
        [options]="anwenderbetriebOptions"
        [twoColumns]="true"
        id="anwenderbetriebId"
        label="USERS.ANWENDERBETRIEB"></app-form-dropdown>
    }

    <app-form-multiselect
      [form]="form"
      [options]="mandantOptions"
      [twoColumns]="true"
      id="mandantIds"
      label="USERS.MANDANT"></app-form-multiselect>

    @if (isRodixAdmin()) {
      <app-form-dropdown
        [form]="form"
        [options]="roleOptions"
        [twoColumns]="true"
        id="role"
        label="USERS.ROLE"
        placeholder="GLOBAL.CHOOSE"></app-form-dropdown>
    }

    <app-form-text-input [form]="form" [twoColumns]="true" id="username" label="USERS.USERNAME"></app-form-text-input>

    <app-form-text-input [form]="form" [twoColumns]="true" id="email" label="GLOBAL.EMAIL"></app-form-text-input>

    <app-form-text-input
      [form]="form"
      [twoColumns]="true"
      id="firstName"
      label="GLOBAL.FIRST_NAME"></app-form-text-input>

    <app-form-text-input [form]="form" [twoColumns]="true" id="lastName" label="GLOBAL.LAST_NAME"></app-form-text-input>

    @if (isRodixAdmin()) {
      <app-form-switch [form]="form" [twoColumns]="true" id="betaTester" label="USERS.BETA_TESTER"></app-form-switch>
    }

    <app-form-button-bar [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
</p-card>
